<script>
import { ref } from 'vue'


export default {
	name: "Modal-consol-list",
	props: {
    selectedOrders: Array
	},
	emits: [
		"close-modal",
    "refresh-list"
	],
  data() {
    return {
      consolList: ref([]),
      selectedConsol: null,
      loading: false,
      etdRange: this.getDefaultEtdRange(),
      columns : [
        { name: 'statusLabel', label: '상태', align: 'center', field: 'statusLabel', sortable: true },
        { name: 'mblNo', label: 'M B/L No.', align: 'center', field: 'mblNo', sortable: true },
        { name: 'freightCode', label: '편명(선명)', align: 'center', field: 'freightCode', sortable: true },
        { name: 'route', label: '구간', align: 'center', field: row => `${row.departCity || '-'} -> ${row.arrivalCity || '-'}` },
        { name: 'schedule', label: '일정', align: 'center', field: row => `${row.etd || '-'} / ${row.eta || '-'}` },
        { name: 'totalOrderQty', label: '오더', align: 'center', field: 'totalOrderQty', sortable: true },
        { name: 'totalQty', label: '수량', align: 'center', field: 'totalQty', sortable: true },
        { name: 'totalWeight', label: '중량', align: 'center', field: 'totalWeight', sortable: true },
        { name: 'totalVolumeWeight', label: '부피중량', align: 'center', field: 'totalVolumeWeight', sortable: true },
        { name: 'memo', label: '메모', align: 'left', field: 'memo' },
        { name: 'action', label: '연결', align: 'center', field: 'action' },
      ],
    }
  },
  computed: {
    selectedSummary() {
      const rows = Array.isArray(this.selectedOrders) ? this.selectedOrders : []
      const partnerSet = new Set()
      const totalQty = rows.reduce((sum, row) => {
        if (row.partnerName) partnerSet.add(row.partnerName)
        return sum + Number(row.totalQty || row.boxQty || 0)
      }, 0)
      const totalWeight = rows.reduce((sum, row) => {
        return sum + Number(row.weight || row.totalWeight || 0)
      }, 0)

      return {
        orderCount: rows.length,
        partnerCount: partnerSet.size,
        totalQty,
        totalWeight: Math.round(totalWeight * 100) / 100
      }
    },
    selectedConsolLabel() {
      if (!this.selectedConsol) return "선택된 콘솔 없음"
      return `${this.selectedConsol.mblNo || '-'} / ${this.selectedConsol.freightCode || '-'}`
    }
  },
	methods: {
    formatDate(date) {
      const pad = (value) => String(value).padStart(2, "0")
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
    },

    getDefaultEtdRange() {
      const today = new Date()
      const to = new Date()
      to.setMonth(to.getMonth() + 1)

      return {
        from: this.formatDate(today),
        to: this.formatDate(to)
      }
    },

    /**
     * Title        : 콘솔목록 불러오기
     * Status       : Actived
     * Description  : 선택가능한 콘솔 목록을 불러온다
     */
    async loadConsolList(){
      const payload = {
        status: '001',
        etd: this.etdRange
      }

      let config = {
        method : "POST",
        url : "/api/consol/getConsolList",
        data : payload,
        name : "[ Axios / 콘솔목록 불러오기 ]"
      }

      this.loading = true
      await this.$http(config)
        .then((res) => {
          this.$log.info("콘솔목록 불러오기")
          this.consolList = res.data
          this.$log.debug("[ Axios / 콘솔목록 불러오기 ] 성공 => ", res.data)
        })
        .catch((err) => {
          this.$log.error("[ Axios / 콘솔목록 불러오기 ] 실패 =>", err)
        })
        .finally(() => {
          this.loading = false
        })
    },


    /**
     * Title        : Row click
     * Status       : Actived
     * Description  : 선택된 화물의 정보를 변경하기 위한 모달 호출
     */
    onRowClick (evt, row) {
      this.$log.debug('[ 선택된 콘솔 ] = ', row)
      this.selectedConsol = row
    },

    async linkSelectedConsol (row = this.selectedConsol) {
      if (!row) return

      const confirmMessage = [
        `선택한 ${this.selectedSummary.orderCount}건을 콘솔에 연결하시겠습니까?`,
        `MBL: ${row.mblNo || '-'}`,
        `편명/선명: ${row.freightCode || '-'}`,
        `일정: ${row.etd || '-'} / ${row.eta || '-'}`
      ].join('\n')

      if(confirm(confirmMessage)){
        const newArr = this.selectedOrders.map(item => item.id)

        const payload = {
          consolId : row.id,
          orderList : newArr
        }

        let config = {
          method : "POST",
          url : "/api/consol/linkConsol",
          data : payload,
          name : "[ Axios / 콘솔에 연결하기 ]"
        }

        await this.$http(config)
          .then((res) => {
            this.$log.info("콘솔에 연결하기")
            this.consolList = res.data
            this.$emit("refresh-list")
            this.$emit("close-modal")
            this.$log.debug("[ Axios / 콘솔에 연결하기 ] 성공 => ", res.data)
          })
          .catch((err) => {
            this.$log.error("[ Axios / 콘솔에 연결하기 ] 실패 =>", err)
          })
      }
    },
		
		// 모달닫기
		closeModal() {
			this.$emit("close-modal")
		},
	},
  mounted(){
    this.loadConsolList()
  }
}
</script>
<template>

  <q-card style="width: 1180px; max-width: 95vw;">
    <q-card-section>
      <div class="row items-start justify-between q-col-gutter-md">
        <div class="col">
          <div class="text-h6">콘솔 선택</div>
          <div class="text-caption text-grey-7">
            선택한 임시콘솔 대기 건을 출항 대기 콘솔에 연결합니다.
          </div>
          <div class="consol-range-notice q-mt-sm">
            <q-icon name="event" size="16px" />
            <span>
              ETD 기준 {{ etdRange.from }} ~ {{ etdRange.to }} 출항대기 콘솔만 표시됩니다.
            </span>
          </div>
        </div>
        <div class="col-auto">
          <q-btn
            @click="closeModal()" 
            flat v-close-popup round dense icon="close" />
        </div>
      </div>
      <div></div>
    </q-card-section>

    <q-card-section class="q-pt-none">
      <div class="row q-col-gutter-sm q-mb-md">
        <div class="col-6 col-md-3">
          <div class="consol-summary">
            <div class="text-caption text-grey-7">선택 오더</div>
            <div class="text-h6">{{ selectedSummary.orderCount }}</div>
          </div>
        </div>
        <div class="col-6 col-md-3">
          <div class="consol-summary">
            <div class="text-caption text-grey-7">파트너</div>
            <div class="text-h6">{{ selectedSummary.partnerCount }}</div>
          </div>
        </div>
        <div class="col-6 col-md-3">
          <div class="consol-summary">
            <div class="text-caption text-grey-7">총 수량</div>
            <div class="text-h6">{{ selectedSummary.totalQty }}</div>
          </div>
        </div>
        <div class="col-6 col-md-3">
          <div class="consol-summary">
            <div class="text-caption text-grey-7">총 중량</div>
            <div class="text-h6">{{ selectedSummary.totalWeight }}kg</div>
          </div>
        </div>
      </div>

      <div class="row items-center q-mb-sm">
        <div class="col">
          <q-badge color="primary" outline class="q-pa-sm">
            {{ selectedConsolLabel }}
          </q-badge>
        </div>
        <div class="col-auto">
          <q-btn
            color="grey-7"
            outline
            icon="refresh"
            label="새로고침"
            class="q-mr-sm"
            :loading="loading"
            @click="loadConsolList" />
          <q-btn
            color="primary"
            icon="link"
            label="선택 콘솔에 연결"
            :disable="!selectedConsol || selectedSummary.orderCount === 0"
            @click="linkSelectedConsol" />
        </div>
      </div>

      <div class="row">
        <div class="col">
          <q-table
            class="my-sticky-virtscroll-table"
            virtual-scroll
            :loading="loading"
            :rows-per-page-options="[0]"
            :virtual-scroll-sticky-size-start="48"
            :rows="consolList"
            :columns="columns"
            @row-click="onRowClick"
            row-key="id">
            <template v-slot:body="props">
              <q-tr
                :props="props"
                :class="selectedConsol && selectedConsol.id === props.row.id ? 'bg-blue-1 text-blue-10' : ''"
                @click="onRowClick($event, props.row)">
                <q-td v-for="col in props.cols" :key="col.name" :props="props">
                  <template v-if="col.name === 'statusLabel'">
                    <q-badge color="teal" text-color="white">
                      {{ col.value || '-' }}
                    </q-badge>
                  </template>
                  <template v-else-if="col.name === 'action'">
                    <q-btn
                      color="primary"
                      dense
                      outline
                      icon="link"
                      label="연결"
                      @click.stop="linkSelectedConsol(props.row)" />
                  </template>
                  <template v-else-if="col.name === 'memo'">
                    <div class="consol-memo">{{ col.value || '-' }}</div>
                  </template>
                  <template v-else>
                    {{ col.value || '-' }}
                  </template>
                </q-td>
              </q-tr>
            </template>
          </q-table>
        </div>
      </div>
    </q-card-section>
  </q-card>

</template>

<style scoped>
.consol-memo {
  max-width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.consol-range-notice {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 8px;
  border: 1px solid #d8e2ec;
  border-radius: 6px;
  background: #f8fafc;
  color: #52616f;
  font-size: 12px;
}

.consol-summary {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 8px 10px;
  background: #fafafa;
}
</style>
